import { type Action, configureStore, type EnhancedStore } from '@reduxjs/toolkit';
import { createRouterMiddleware } from 'connected-next-router';
import LogRocket from 'logrocket';

import { UPLOADER_SERIALIZABLE_CHECK } from '@air/redux-uploader';

import createRootReducer from '~/store/rootReducer';
import { selectedItemsPersistenceMiddleware } from '~/store/selectedItems/persistenceMiddleware';
import { type AirState } from '~/store/types';

let globalStore: null | {
  store: EnhancedStore<AirState, Action>;
} = null;

export const makeStore = (preloadedState?: Partial<AirState>) => {
  let _globalStore: typeof globalStore = globalStore
    ? globalStore
    : {
        store: configureStore({
          devTools: process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production',
          reducer: createRootReducer(),
          middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
              serializableCheck: UPLOADER_SERIALIZABLE_CHECK,
            })
              .concat(createRouterMiddleware(), LogRocket.reduxMiddleware())
              .concat(selectedItemsPersistenceMiddleware),
          preloadedState: preloadedState as AirState,
        }),
      };

  if (preloadedState && globalStore) {
    const existingState = globalStore.store.getState();
    _globalStore = {
      store: configureStore({
        devTools: process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production',
        reducer: createRootReducer(),
        middleware: (getDefaultMiddleware) =>
          getDefaultMiddleware({
            serializableCheck: UPLOADER_SERIALIZABLE_CHECK,
          })
            .concat(createRouterMiddleware(), LogRocket.reduxMiddleware())
            .concat(selectedItemsPersistenceMiddleware),
        preloadedState: {
          ...existingState,
          ...preloadedState,
        } as AirState,
      }),
    };
    globalStore = null;
  }

  if (typeof window === 'undefined') {
    return _globalStore;
  }

  if (!globalStore) {
    globalStore = _globalStore;
  }

  return _globalStore;
};
